import React, { useContext, useEffect, useRef, useState } from "react";
import { searchPaymentMode } from "./utils";
import { endpoint, pages } from "../../common/constant";
import {
  dropdownMapping,
  fetchAllPostPromisedData,
  fetchDetails,
} from "../../common/utils/methods/commonMethods/utilityMethod";
import ListComponent from "./PaymentModeListComponent";
import { ReactComponent as BackArrow } from "assets/img/svg/BackArrow.svg";


import {
  companyCodeUrl,
  findObjById,
  getUpdatedFilterRequest,
  groupCodeurl,
  payModeCategoryUrl,
  termDate,
} from "./constant";
import { getCreateReqBody } from "./constant";
import {
  failureToast,
  successToast,
} from "../../common/utils/methods/toasterFunctions/function";
import { Card } from "reactstrap";
import AButton from "../../common/form-fields-mui/AButton";
import Filters from "./Filters";
import { RolePermissions } from "appContext";
import { PermissionContext } from "appContext";
import { PermisionDenied } from "../../common/commonComponents";

const PaymentModeMaster = () => {
  const [groupCodeList, setGroupCodeData] = useState([]);
  const [companyCodeList, setCompanyCodeList] = useState([]);
  const [rows, setRows] = useState([]);
  const [currentPage, setCurrentPage] = useState(0);
  const [rowCount, setRowCount] = useState(0);
  const [loader, setLoader] = useState(false);
  const [paymentCategoryList, setPaymentCategory] = useState([]);
  const [isLastPage, setIsLastPage] = useState(false);
  const [isNew, setIsNew] = useState(false);
  const listRef = useRef();
  const [globalFilter, setGlobalFilter] = useState({
    searchField: "paymentMode",
  });
  // const history=useHistory()
  const permissions = useContext(PermissionContext);
  const userPermissions = RolePermissions(
    permissions,
    pages["paymentMode"]["id"]
  );
  useEffect(() => {
    const getData = async () => {
      await getDropdowns();
      getPaymentModeListing();
    };
    getData();
  }, []);
  const getPaymentModeListing = async (req = {}, page = 0) => {
    setLoader(true);
    const res = await searchPaymentMode(req, page);
    setRows(res);
    setIsLastPage && setIsLastPage(!res.length > 0);
    setRowCount(res.length);
    listRef.current.stopEditing();
    setLoader(false);
  };
  const getDropdowns = async () => {
    setLoader(true);
    const dropdowns = await Promise.all([
      dropdownMapping(groupCodeurl, "groupCodeDispValue", "groupCodeKey"),
      dropdownMapping(companyCodeUrl, "companyCodeDispValue", "companyCodeKey"),
      dropdownMapping(payModeCategoryUrl, "displayValue", "id"),
    ]);
    setLoader(false);
    setGroupCodeData(dropdowns[0]);
    setCompanyCodeList(dropdowns[1]);
    setPaymentCategory(dropdowns[2]);
  };
  const onPageChange = (newPage) => {
    setCurrentPage(newPage);
    getPaymentModeListing({}, newPage);
  };

  const createHandler = async (rowData) => {
    setLoader(true);
    const reqBody = getCreateReqBody(rowData);
    try {
      const res = await fetchAllPostPromisedData(
        endpoint?.paymentMode.create,
        reqBody,
        "post"
      );
      if (res?.code === 200) {
        listRef.current.stopEditing();
        successToast(res?.message);
        getPaymentModeListing({}, 0);
      }
    } catch (error) {
      console.log(error);
    } finally {
      setLoader(false);
    }
  };
  const updateHandler = async (rowData) => {
    setLoader(true);
    const reqBody = getCreateReqBody(rowData);
    try {
      const res = await fetchAllPostPromisedData(
        `${endpoint.paymentMode.update}/${rowData?.id}`,
        reqBody,
        "put"
      );
      if (res?.code === 200) {
        successToast(res?.message);
        listRef.current.stopEditing();
        getPaymentModeListing({}, currentPage);
      } else {
        failureToast(res?.message);
      }
    } catch (error) {
      console.log(error);
    } finally {
      setLoader(false);
    }
  };
  const crossInputHandler = () => {
    const filter = getUpdatedFilterRequest({
      ...globalFilter,
      paymentMode: "",
      paymentModeDesc: "",
    });
    setGlobalFilter({ ...globalFilter, paymentMode: "", paymentModeDesc: "" });
    getPaymentModeListing(filter);
  };

  const searchInputValueHandler = () => {
    const filter = getUpdatedFilterRequest(globalFilter);
    getPaymentModeListing(filter);
  };

  return userPermissions ? (
    <Card className="mx-2">
      <div className="d-flex justify-content-between mt-3 mb-2 mx-2">
        <div className="d-flex justify-content-between mt-2">
          <BackArrow className="color-black mr-2 cursor" onClick={() => {}} />
          <h4 className="color-black" style={{ lineHeight: "1.7" }}>
            Payment mode master
          </h4>
        </div>

        <div className="d-flex justify-content-between" style={{ gap: "10px" }}>
          <Filters
            paymentCategoryDropdown={paymentCategoryList}
            globalFilter={globalFilter}
            setGlobalFilter={setGlobalFilter}
            getPaymentModeListing={getPaymentModeListing}
            crossInputHandler={crossInputHandler}
            searchInputValueHandler={searchInputValueHandler}
            isLoading={loader}
          />
          <AButton
            variant="primary_filled"
            size="xs"
            className="no-ml-btn"
            onClick={() => listRef.current.addNewRow()}
          >
            + Add new row
          </AButton>
        </div>
      </div>
      <ListComponent
        ref={listRef}
        rows={rows}
        loader={loader}
        createHandler={createHandler}
        updateHandler={updateHandler}
        currentPage={currentPage || 0}
        rowCount={rowCount}
        paymentCategoryList={paymentCategoryList}
        companyCodeList={companyCodeList}
        groupCodeList={groupCodeList}
        onPageChange={onPageChange}
        isLastPage={isLastPage}
        isNew={isNew}
        setIsNew={setIsNew}
      />
    </Card>
  ) : (
    <PermisionDenied />
  );
};
export default PaymentModeMaster;
